import { useRecoilValue, useResetRecoilState, useSetRecoilState } from "recoil";
import { myNewsEnabledState } from "my-news/states/my-news-enabled-state";

export const useMyNewsEnabled = () => {
  const state = useRecoilValue(myNewsEnabledState);
  const setState = useSetRecoilState(myNewsEnabledState);
  const resetState = useResetRecoilState(myNewsEnabledState);

  return { state, setState, resetState };
};

export default useMyNewsEnabled;
